const pad = (n) => String(n).padStart(2, "0");

// Interpret date (YYYY-MM-DD) + time (HH:MM, 24h) as Singapore time (UTC+8)
const sgt = (date, time) => new Date(`${date}T${time || "00:00"}:00+08:00`);

const utcStamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

const dateStamp = (date) => date.replace(/-/g, "");

const nextDay = (date) => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}`;
};

const escapeICS = (s = "") => s.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r?\n/g, "\\n");

const range = (ev) =>
  ev.start
    ? { google: `${utcStamp(sgt(ev.date, ev.start))}/${utcStamp(sgt(ev.date, ev.end || ev.start))}`, allDay: false }
    : { google: `${dateStamp(ev.date)}/${nextDay(ev.date)}`, allDay: true };

export const googleCalUrl = (ev) => {
  const p = new URLSearchParams({ action: "TEMPLATE", text: ev.title || "" });
  if (ev.details) p.set("details", ev.details);
  if (ev.location) p.set("location", ev.location);
  p.set("dates", range(ev).google);
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

export const icsContent = (ev) => {
  const r = range(ev);
  const [ds, de] = ev.start
    ? [`DTSTART:${utcStamp(sgt(ev.date, ev.start))}`, `DTEND:${utcStamp(sgt(ev.date, ev.end || ev.start))}`]
    : [`DTSTART;VALUE=DATE:${dateStamp(ev.date)}`, `DTEND;VALUE=DATE:${nextDay(ev.date)}`];
  void r;
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Affinity Group//Events//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${dateStamp(ev.date)}-${Math.random().toString(36).slice(2)}@affinitygroup.sg`,
    `DTSTAMP:${utcStamp(new Date())}`,
    ds,
    de,
    `SUMMARY:${escapeICS(ev.title)}`,
    ev.details ? `DESCRIPTION:${escapeICS(ev.details)}` : "",
    ev.location ? `LOCATION:${escapeICS(ev.location)}` : "",
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");
};

export const downloadIcs = (ev) => {
  const blob = new Blob([icsContent(ev)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(ev.title || "event").replace(/[^\w]+/g, "-").slice(0, 48)}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
